module.exports = __webpack_public_path__ + "img/loki.495e9161.png";